export const roleType = {
  isType: 2,
};
